import { render, staticRenderFns } from "./ExchangeGift.vue?vue&type=template&id=6f0e0c8d&scoped=true"
import script from "./ExchangeGift.vue?vue&type=script&lang=js"
export * from "./ExchangeGift.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0e0c8d",
  null
  
)

export default component.exports